import React from 'react'
import {
  Box,
  Card,
  CardBody,
  Flex,
  Skeleton
} from '@chakra-ui/react'
import Header from '../../Header'
import { LoadingStateProps } from '../types'

const LoadingState = ({ title, subtitle }: LoadingStateProps) => (
  <Box p={{ base: 2, md: 4 }}>
    <Header title={title} subtitle={subtitle} />
    <Card mb={6}>
      <CardBody>
        <Flex direction="column" gap={4}>
          <Skeleton height="80px" />
          <Skeleton height="40px" />
          <Skeleton height="200px" />
        </Flex>
      </CardBody>
    </Card>
  </Box>
)

export default LoadingState
